import { PageResponse, PageRequest } from '..';

export class ReceiverPageResponse extends PageResponse {
    content: Receiver[];
}

export class ReceiverPageRequest extends PageRequest {
    projectId?: string;
    event?: string;
}

export class Receiver {
    id: string;
    instanceId: number;
    ipAddress: string;
    troglodyteVersion: string;
    status: string;
    statusReason: string;
    creationDate: string;
    modifyDate: string;
    lastOkHealthCheck: string;
}
